var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM3Icon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 14.9999C4.65909 14.9999 5.93086 15.5267 6.86854 16.4644C7.80622 17.4021 8.33301 18.6738 8.33301 19.9999C8.33301 21.326 7.80622 22.5978 6.86854 23.5355C5.93086 24.4731 4.65909 24.9999 3.33301 24.9999V28.3333C3.33301 29.2173 3.6842 30.0652 4.30932 30.6903C4.93444 31.3154 5.78229 31.6666 6.66634 31.6666H33.333C34.2171 31.6666 35.0649 31.3154 35.69 30.6903C36.3152 30.0652 36.6663 29.2173 36.6663 28.3333V24.9999C35.3403 24.9999 34.0685 24.4731 33.1308 23.5355C32.1931 22.5978 31.6663 21.326 31.6663 19.9999C31.6663 18.6738 32.1931 17.4021 33.1308 16.4644C34.0685 15.5267 35.3403 14.9999 36.6663 14.9999V11.6666C36.6663 10.7825 36.3152 9.93468 35.69 9.30956C35.0649 8.68444 34.2171 8.33325 33.333 8.33325H6.66634C5.78229 8.33325 4.93444 8.68444 4.30932 9.30956C3.6842 9.93468 3.33301 10.7825 3.33301 11.6666V14.9999Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 8.33325V11.6666",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 28.3333V31.6666",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 18.3333V21.6666",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM3Icon);
export default __webpack_public_path__ + "static/media/m3Icon.b8c8e87e748e0c196361783b1f0a30ff.svg";
export { ForwardRef as ReactComponent };